import _ from 'lodash'
import React, { Fragment } from 'react'
import { createPortal } from 'react-dom'

export default class Modal extends React.Component {
  static defaultProps = {
    onClose: _.noop,
    onMount: _.noop,
    onUpdate: _.noop,
    isOpen: false,
    trigger: () => null,
    dontShowCloseBtn: false,
    maxWidth: '700px'
  }

  constructor(props) {
    super(props)

    this.state = {
      show: false
    }

    this.portalDiv = document.createElement('div')
    this.portalDivBackdrop = document.createElement('div')

    document.body.appendChild(this.portalDiv)
    document.body.appendChild(this.portalDivBackdrop)
  }

  componentDidMount() {
    if (this.props.isOpen) {
      this.openModal()
      this.props.onUpdate(this.state)
    }

    if (this.props.onMount) {
      this.props.onMount()
    }
  }

  componentWillUnmount() {
    document.body.removeAttribute('style')
    document.body.removeChild(this.portalDiv)
    document.body.removeChild(this.portalDivBackdrop)
  }

  componentDidUpdate() {
    if (this.props.onUpdate) {
      this.props.onUpdate(this.state)
    }
  }

  openModal = () => {
    document.body.style.overflow = 'hidden'
    this.setState({ show: true })
  }

  closeModal = () => {
    document.body.removeAttribute('style')
    this.setState({ show: false })
  }

  render () {
    let { title, trigger, body, footer, onClose, dontShowCloseBtn, maxWidth } = this.props

    if (!this.state.show) {
      return trigger(this.openModal)
    }

    return (
      <Fragment>
        {trigger(this.openModal)}
        {createPortal(
          <div className="modal d-inline-block show" role="dialog" style={{ overflow: 'auto' }}>
            <div className="modal-dialog" role="document"  style={{ maxWidth }}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{title}</h5>
                  {!dontShowCloseBtn &&
                    <button
                      type="button"
                      className="close"
                      onClick={() => {
                        this.closeModal()
                        onClose()
                      }}
                      aria-label="Close"
                      >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  }
                </div>
                <div className="modal-body">
                  {_.isFunction(body) ? body(this.closeModal) : body}
                </div>
                {footer &&
                  <div className="modal-footer">
                    {_.isFunction(footer) ? footer(this.closeModal) : footer}
                  </div>
                }
              </div>
            </div>
          </div>,
          this.portalDiv
        )}
        {createPortal(
          <div className="modal-backdrop fade show"></div>,
          this.portalDivBackdrop
        )}
      </Fragment>
    )
  }
}
